export default "__VITE_ASSET__e12578ff__"